module.exports = {
  entry: './src/apps/privacy-dsr-form/index.tsx',
  shortcode: 'privacy-dsr-form',
  title: 'Privacy DSR Form',
  status: 'stable',
  description: 'Allows users to explore the DSR Form.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-Privacy-DSR-Form-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
